import Api from '../../services/Api';

export default {
  namespaced: true,
  state: {
    countryOptions: [],
    regionOptions: {
      Lebanon: ['Akkar', 'Baalbak - Hermel', 'Beirut', 'Bekaa', 'Mount Lebanon', 'Nabatiyeh', 'North', 'South'],
      Spain: ['Comunidad de Madrid', 'Comunidad Foral de Navarra', 'Comunidad Valenciana', 'Extremadura', 'Galicia', 'Islas Baleares', 'Islas Canarias', 'La Rioja', 'País Vasco', 'Principado de Asturias', 'Región de Murcia', 'Andalucía', 'Aragón', 'Cantabria', 'Castilla-La Mancha', 'Castilla y León', 'Cataluña', 'Ceuta y Melilla'],
      Tunisia: ['Ariana', 'Béja', 'Ben Arous (Tunis Sud)', 'Bizerte', 'Gabès', 'Gafsa', 'Jendouba', 'Kairouan', 'Kassérine', 'Kebili', 'Le Kef', 'Mahdia', 'Manubah', 'Médenine', 'Monastir', 'Nabeul', 'Sfax', 'Sidi Bou Zid', 'Siliana', 'Sousse', 'Tataouine', 'Tozeur', 'Tunis', 'Zaghouan'],
    },
    currentRegion: '',
    floorOptions: ['Arcillo Arenoso', 'Arcillo Limoso', 'Arcilloso', 'Arenoso', 'Arenoso Franco', 'Franco', 'Franco Arcillo Arenoso',
      'Franco Arcillo Limoso', 'Franco Arcilloso', 'Franco Arenoso', 'Franco Limoso'],
    currentFloor: '',
    currentUsefulLife: null,
    currentPercentageOfStoniness: null,
    cropsOptions: [],
    currentCrops: [],
    cropsData: {},
    barbechoData: {
      name: 'Barbecho', // Cultivo
      calendarFirstDate: '', // Fecha de siembra
      harvestYearJump: false, // Cosecha en mismo año natural
      maxPerformance: 0, // Rendimiento máximo
      surfaceLimit: 0, // Superficie máxima
      totalIrrigationLimit: 0, // Dosis máxima de riego
      cost: 0, // Costes de cultivo
      cropAids: 0, // Subvenciones
    },
    currentAvailableVolume: null,
    currentIrrigationWaterCost: null,
    currentMaximumIrrigation: null,
    currentMinimumIrrigation: null,
    currentMaximumIrrigationDose: null,
    currentMinimumIrrigationDose: null,
    currentEfficiency: null,

    suboptimizationModelOptions: ['Riego/Rendimiento', 'Riego/Rendimiento/Precipitación', 'Riego/Rendimiento/Precipitación/Superficie'],
    currentSuboptimizationModel: '',
    currentNumberOfPointsInTheFunction: null,
    currentInitialSoilMoisture: null,
    currentSoilWaterFillLevel: null,
    currentSoilWaterDepletionLevel: null,
    currentPoint: {
      pointName: '',
      stationName: '',
      stationID: '',
      provinceName: '',
      provinceID: '',
      country: '',
      irrigableSurface: '',
    },
    showOptimalCropDistribution: false,
    showFloor: false,
    showIrrigation: false,
    showCrops: false,
    mopecoModel: {},
    requestMopecoModel: {},
    defaultIrrigationValues: {},
  },
  actions: {
    updateCurrentPoint(context, point) {
      context.commit('clearAll');
      context.commit('updateCurrentPoint', point);
    },

    async fetchCountries(context) {
      try {
        const xhr = await Api.getAllCountries();
        const responseFormated = [];
        for (const country of JSON.parse(xhr.response)) {
          responseFormated.push(country.name);
        }
        context.commit('setCountryOptions', responseFormated);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(JSON.parse(error.message).code);
      }
    },

    setCurrentFloor(context, value) {
      context.commit('setCurrentFloor', value);
    },

    setCurrentUsefulLife(context, value) {
      context.commit('setCurrentUsefulLife', value);
    },

    setCurrentPercentageOfStoniness(context, value) {
      context.commit('setCurrentPercentageOfStoniness', value);
    },

    setCropsData(context, value) {
      context.commit('setCropsData', value);
    },

    updateCropData(context, crop) {
      context.commit('updateCropData', crop);
    },

    setCurrentAvailableVolume(context, value) {
      context.commit('setCurrentAvailableVolume', value);
    },

    setCurrentIrrigationWaterCost(context, value) {
      context.commit('setCurrentIrrigationWaterCost', value);
    },

    setCurrentMaximumIrrigation(context, value) {
      context.commit('setCurrentMaximumIrrigation', value);
    },

    setCurrentMinimumIrrigation(context, value) {
      context.commit('setCurrentMinimumIrrigation', value);
    },

    setCurrentMaximumIrrigationDose(context, value) {
      context.commit('setCurrentMaximumIrrigationDose', value);
    },

    setCurrentMinimumIrrigationDose(context, value) {
      context.commit('setCurrentMinimumIrrigationDose', value);
    },

    setCurrentEfficiency(context, value) {
      context.commit('setCurrentEfficiency', value);
    },

    setCurrentSuboptimizationModel(context, value) {
      context.commit('setCurrentSuboptimizationModel', value);
    },

    setCurrentNumberOfPointsInTheFunction(context, value) {
      context.commit('setCurrentNumberOfPointsInTheFunction', value);
    },

    setCurrentInitialSoilMoisture(context, value) {
      context.commit('setCurrentInitialSoilMoisture', value);
    },

    setCurrentSoilWaterFillLevel(context, value) {
      context.commit('setCurrentSoilWaterFillLevel', value);
    },

    setCurrentSoilWaterDepletionLevel(context, value) {
      context.commit('setCurrentSoilWaterDepletionLevel', value);
    },

    async setCropsOptions({ commit, state }) {
      try {
        if (Object.keys(state.cropsData).length !== 0) return Promise.resolve();
        const xhr = await Api.getCropsByRegion(state.currentRegion);
        const crops = JSON.parse(xhr.response);
        const cropsOptions = [];
        const cropsData = {};
        for (const crop of crops) {
          const cropName = crop.name;
          cropsOptions.push(cropName);
          cropsData[`${crop.name}`] = crop;
        }
        commit('setCropsOptions', cropsOptions);
        commit('setCropsData', cropsData);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(JSON.parse(error.message).code);
      }
    },

    setCurrentCrops(context, value) {
      context.commit('setCurrentCrops', value);
    },

    clearAll(context) {
      context.commit('clearAll');
    },

    setBarbechoData(context, value) {
      context.commit('setBarbechoData', value);
    },

    setShowFloor(context, value) {
      context.commit('setShowFloor', value);
    },

    setShowIrrigation(context, value) {
      context.commit('setShowIrrigation', value);
    },

    setShowCrops(context, value) {
      context.commit('setShowCrops', value);
    },

    setShowOptimalCropDistribution(context, value) {
      context.commit('setShowOptimalCropDistribution', value);
    },

    async setMopecoModel({ commit, state }) {
      const crops = [];
      for (const crop of state.currentCrops) {
        crops.push(state.cropsData[crop]);
      }
      let optimizationSubmodel = '';
      switch (state.currentSuboptimizationModel) {
        case 'Riego/Rendimiento':
          optimizationSubmodel = 'OptSubmodelP';
          break;
        case 'Riego/Rendimiento/Precipitación':
          optimizationSubmodel = 'OptSubmodelPPef';
          break;
        default:
          optimizationSubmodel = 'OptSubmodelPPefS';
          break;
      }
      const body = {
        availableSurface: state.currentPoint.irrigableSurface,
        availableWater: state.currentAvailableVolume,
        fellowSurfaceLimit: state.barbechoData.surfaceLimit,
        fellowVariableCosts: state.barbechoData.cost,
        fellowGrossMargin: state.barbechoData.cropAids,
        RAWDepletionLevel: state.currentSoilWaterDepletionLevel,
        RAWRefillLevel: state.currentSoilWaterFillLevel,
        soilDepth: state.currentUsefulLife,
        beginningAvailableWater: state.currentInitialSoilMoisture,
        stones: state.currentPercentageOfStoniness,
        minIrrigationDepth: state.currentMinimumIrrigationDose,
        maxIrrigationDepth: state.currentMaximumIrrigationDose,
        uniformityCoefficiency: 99, // Es un valor por defecto establecido por SUPROMED
        waterCost: state.currentIrrigationWaterCost,
        curveResolution: state.currentNumberOfPointsInTheFunction,
        optimizationSubmodel,
        name: state.currentPoint.pointName,
        soilName: state.currentFloor,
        efficiency: state.currentEfficiency,
        crops,
        climateStation: {
          station_id: state.currentPoint.stationID,
          province: state.currentPoint.provinceID,
        },
      };
      try {
        const xhr = await Api.createMopecoModel(body, state.currentRegion);
        const mopecoModel = JSON.parse(xhr.response);
        commit('setMopecoModel', mopecoModel);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(JSON.parse(error.message).code);
      }
    },
    async fetchDefaultIrrigationValues(context) {
      try {
        const xhr = await Api.getDefaultIrrigationValues();
        context.commit('setDefaultIrrigationValues', JSON.parse(xhr.response));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(JSON.parse(error.message).code);
      }
    },
  },
  mutations: {
    updateCurrentPoint(state, point) {
      state.currentPoint.pointName = point.pointName;
      state.currentPoint.stationName = point.stationName;
      state.currentPoint.stationID = point.stationID;
      state.currentPoint.provinceName = point.provinceName;
      state.currentPoint.provinceID = point.provinceID;
      state.currentPoint.country = point.country;
      state.currentPoint.irrigableSurface = point.irrigableSurface;
      state.currentRegion = point.region;
    },
    setCountryOptions(state, value) {
      state.countryOptions = value;
    },
    setCropsOptions(state, value) {
      state.cropsOptions = value;
    },
    setCropsData(state, value) {
      state.cropsData = value;
    },
    updateCropData(state, crop) {
      state.cropsData[crop.name] = crop;
    },
    setCurrentCrops(state, value) {
      state.currentCrops = value;
    },
    setCurrentFloor(state, value) {
      state.currentFloor = value;
    },
    setCurrentUsefulLife(state, value) {
      state.currentUsefulLife = value;
    },
    setCurrentPercentageOfStoniness(state, value) {
      state.currentPercentageOfStoniness = value;
    },
    setBarbechoData(state, value) {
      state.barbechoData = value;
    },

    setCurrentAvailableVolume(state, value) {
      state.currentAvailableVolume = value;
    },

    setCurrentIrrigationWaterCost(state, value) {
      state.currentIrrigationWaterCost = value;
    },

    setCurrentMaximumIrrigation(state, value) {
      state.currentMaximumIrrigation = value;
    },

    setCurrentMinimumIrrigation(state, value) {
      state.currentMinimumIrrigation = value;
    },

    setCurrentMaximumIrrigationDose(state, value) {
      state.currentMaximumIrrigationDose = value;
    },

    setCurrentMinimumIrrigationDose(state, value) {
      state.currentMinimumIrrigationDose = value;
    },

    setCurrentEfficiency(state, value) {
      state.currentEfficiency = value;
    },

    setCurrentSuboptimizationModel(state, value) {
      state.currentSuboptimizationModel = value;
    },

    setCurrentNumberOfPointsInTheFunction(state, value) {
      state.currentNumberOfPointsInTheFunction = value;
    },

    setCurrentInitialSoilMoisture(state, value) {
      state.currentInitialSoilMoisture = value;
    },

    setCurrentSoilWaterFillLevel(state, value) {
      state.currentSoilWaterFillLevel = value;
    },

    setCurrentSoilWaterDepletionLevel(state, value) {
      state.currentSoilWaterDepletionLevel = value;
    },

    setShowFloor(state, value) {
      state.showFloor = value;
    },

    setShowIrrigation(state, value) {
      state.showIrrigation = value;
    },

    setShowCrops(state, value) {
      state.showCrops = value;
    },

    setShowOptimalCropDistribution(state, value) {
      state.showOptimalCropDistribution = value;
    },

    setMopecoModel(state, value) {
      state.mopecoModel = value;
    },

    setDefaultIrrigationValues(state, value) {
      state.defaultIrrigationValues = value;
    },
    clearAll(state) {
      state.currentFloor = '';
      state.currentUsefulLife = null;
      state.currentPercentageOfStoniness = null;
      state.currentCrops = [];
      state.cropsData = {};
      state.barbechoData = {
        name: 'Barbecho', // Cultivo
        calendarFirstDate: '', // Fecha de siembra
        harvestYearJump: false, // Cosecha en mismo año natural
        maxPerformance: 0, // Rendimiento máximo
        surfaceLimit: 0, // Superficie máxima
        totalIrrigationLimit: 0, // Dosis máxima de riego
        cost: 0, // Costes de cultivo
        cropAids: 0, // Subvenciones
      };
      state.currentAvailableVolume = null;
      state.currentIrrigationWaterCost = null;
      state.currentMaximumIrrigation = null;
      state.currentMinimumIrrigation = null;
      state.currentMaximumIrrigationDose = null;
      state.currentMinimumIrrigationDose = null;
      state.currentEfficiency = null;
      state.currentSuboptimizationModel = '';
      state.currentNumberOfPointsInTheFunction = null;
      state.currentInitialSoilMoisture = null;
      state.currentSoilWaterFillLevel = null;
      state.currentSoilWaterDepletionLevel = null;
      state.showFloor = false;
      state.showIrrigation = false;
      state.showCrops = false;
      state.showOptimalCropDistribution = false;
      state.mopecoModel = {};
    },
  },
};
